import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.find-index.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, computed, onMounted, ref } from "vue";
import { ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { useI18n } from "vue-i18n";
import ModalModule from "@/store/modules/modal";
import BookingModule from "@/store/modules/booking";
import closeIcon from "@/assets/images/svg/close.svg";
import NotificationService from "@/services/notification.service";
import { LogLevel, LogService } from "@/services/logging";
import { handleErrorAndPrepareMessage } from "@/utils/helpers/common";
import POSConfigModule from "@/store/modules/pos-config";
import UserModule from "@/store/modules/user";
import AuthModule from "@/store/modules/auth";
import { getProductCategoryById } from "@/utils/helpers/product-category";
import { PCTypes } from "@/types/db/product-category";
import CustomersModule from "@/store/modules/customers";
import { BookingStep } from "@/constants/booking";
import { cloneDeep } from "lodash";
import { pullAndStorePCs } from "@/utils/vue-helpers/product-category";
import { selectBooking, toLocalProductSlotBooking } from "@/utils/vue-helpers/booking";
import { POSConfigErrors } from "@/constants/errors/pos-config";
import { getUserAccessToken, getSmtzAuth, getSmtzAuthFromStorage } from "@/utils/helpers/auth";
import { getLanguage } from "@/utils/helpers/lang"; // @ts-ignore

import { SmeetzCalendars } from "/node_modules/@smeetz/calendars/dist/calendars.js";
import "/node_modules/@smeetz/calendars/dist/style.css";
import AppModule from "@/store/modules/app";
import PSSModule from "@/store/modules/pss";
import { addPSSExtensions } from "@/utils/vue-helpers/orders";
import { hasSalesStarted } from "@/utils/vue-helpers/cash-float";
import i18n from "@/lang";
import { createOrderSession } from "@/utils/helpers/product-slot-booking";
import { countPSSByBookingId, getAccountingEntiesByListOfAccountingIds_Paginated, getBookingInfo, getFullBookingById, getOtherTypesAccountingsByBookingId, getPSSBookingId, getTicketTypeAccountingsByBookingIdWithAccEntries_Paginated } from "@/api/gql/product-slot-boooking";
import dayjs from "dayjs";
import { upsertUntypedBooking } from "@/db/untyped-booking";
import { SyncStatus } from "@/types/db/product-slot-booking";
export default defineComponent({
  name: "OccupancyCalendar",
  components: {
    SmeetzCalendars: SmeetzCalendars
  },
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _useI18n, t, closeIconStyle, closeIconContent, closeIconAlt, showCalendar, dialogVisible, getOccupancyTableKey, getUserToken, getGroupId, getUserId, getUserGraphqlToken, env, onCalendar;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              onCalendar = function _onCalendar(value, type) {
                if (value && value._rawData && value._rawData.occupancy_booking_reference && value._rawData.occupancy_booking_reference.raw) {
                  var bookingReference = value._rawData.occupancy_booking_reference.raw; // Lets first check if the order that the user has clicked on is already in the localStorage
                  // If it is, we will just open the order tab without repulling

                  var bookingInState = BookingModule.bookingList.find(function (booking) {
                    return booking.reference === bookingReference;
                  });

                  if (bookingInState) {
                    // We will manually select the booking just because the booking can be in the hidden bookings array
                    console.log("going to manually select the booking");
                    selectBooking(bookingInState.uuid, {
                      fromMoreOrders: true
                    }); // Lets open the order tab

                    console.log("setting animation true");
                    BookingModule.setTabAnimation(true); // lets now close orders table

                    this.close();
                    return;
                  }
                }

                this.selectOrderForEditing(value.occupancyBookingId);
                console.log(type, " - ", value.occupancyBookingId);
              };

              _useI18n = useI18n({}), t = _useI18n.t;
              closeIconStyle = "width: 30px; height: 30px; filter: contrast(170%) invert(100%); cursor: pointer;";
              closeIconContent = closeIcon;
              closeIconAlt = "Close";
              showCalendar = ref(false);
              onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return getSmtzAuth();

                      case 2:
                        showCalendar.value = true;

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
              dialogVisible = dialogVisibleForStatus(ModalStatus.OccupancyCalendar);
              getOccupancyTableKey = computed(function () {
                return UserModule.getUser.elasticSearchTokens.occupancy;
              });
              getUserToken = computed(function () {
                return AuthModule.token || getUserAccessToken();
              });
              getGroupId = computed(function () {
                var groupId = String(POSConfigModule.groupId);
                return groupId;
              });
              getUserId = computed(function () {
                return String(UserModule.userId);
              });
              getUserGraphqlToken = computed(function () {
                return getSmtzAuthFromStorage();
              });
              env = process.env.VUE_APP_ENV;
              return _context2.abrupt("return", {
                t: t,
                dialogVisible: dialogVisible,
                onCalendar: onCalendar,
                getOccupancyTableKey: getOccupancyTableKey,
                getUserToken: getUserToken,
                getGroupId: getGroupId,
                getLanguage: getLanguage,
                getUserGraphqlToken: getUserGraphqlToken,
                getUserId: getUserId,
                showCalendar: showCalendar,
                env: env,
                closeIconStyle: closeIconStyle,
                closeIconContent: closeIconContent,
                closeIconAlt: closeIconAlt
              });

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    close: function close() {
      ModalModule.setStatus(ModalStatus.Hidden);
    },
    selectOrderForEditing: function selectOrderForEditing() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, openTeamsView, selectedOrderId, _pulledBooking, _pulledBooking2, pssCount, isLargeBooking, pulledBooking, booking, bookingId, bookingAccountings, accountingIds, bookingAccountingsEntries, i, accounting, accountingEntries, j, accountingEntry, categoryIds, missingPCs, convertedBooking, orderSession, _i, childPSC, bookingUUID, customer, country, email, phone, _id, company, address, allergies, language, firstName, lastName, title, zipCode, emailMarketingOrganiser, birthDate, city, pssExtensionsCopy, _iterator, _step, pss, pc, creationTime, untypedBooking, errorDetails;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : "123456";

                if (hasSalesStarted.value) {
                  _context3.next = 4;
                  break;
                }

                // do not pull orders if there isn't a sales session open
                NotificationService.showCustomInfoWithTitle(i18n.global.t("common.open-sales-before-edit"), "");
                return _context3.abrupt("return");

              case 4:
                openTeamsView = false;
                selectedOrderId = id; // Show a spinner telling the user to wait till we pull the booking
                // TODO Hamza: now you're showing the spinner in BaseLayout.vue/el-container element and you dynamically override one element z-index,
                // what would be better is attaching the spinner here in Orders.vue with a customized text
                // Try again when you have time

                AppModule.updatedIsLoading(true);
                _context3.prev = 7;
                LogService.info("Going to pull the booking with id: ".concat(selectedOrderId, " from backend")); //// Pulling large bookings logic start
                // TODO Hamza: Count PSS from remote to see if it is a large booking
                // if pssCount > 550 then we consider this booking as a large booking
                // NB: Graphql support a response of 600 nested objects

                _context3.next = 11;
                return countPSSByBookingId(selectedOrderId);

              case 11:
                pssCount = _context3.sent;
                isLargeBooking = pssCount && pssCount > 559 ? true : false; // isLargeBooking = await countPSSByBookingId(selectedOrderId) > 550;
                // countPSSByBookingId: ProductSlotStateCount(where:"(booking_id,eq,7256454)")

                pulledBooking = null;

                if (!isLargeBooking) {
                  _context3.next = 106;
                  break;
                }

                booking = null;
                bookingId = selectedOrderId;
                _context3.prev = 17;
                console.log("calling getBookingInfo");
                _context3.next = 21;
                return getBookingInfo(bookingId);

              case 21:
                booking = _context3.sent;
                _context3.prev = 22;
                console.log("calling getPSSBookingId");
                _context3.next = 26;
                return getPSSBookingId(bookingId);

              case 26:
                booking.pssList = _context3.sent;
                _context3.next = 33;
                break;

              case 29:
                _context3.prev = 29;
                _context3.t0 = _context3["catch"](22);
                console.log("Error when pulling large booking");
                console.log(_context3.t0);

              case 33:
                bookingAccountings = [];
                _context3.prev = 34;
                console.log("calling getTicketTypeAccountingsByBookingIdWithAccEntries_Paginated"); // lets concat the result of the below call to the bookingAccountings

                _context3.t1 = bookingAccountings.push;
                _context3.t2 = bookingAccountings;
                _context3.t3 = _toConsumableArray;
                _context3.next = 41;
                return getTicketTypeAccountingsByBookingIdWithAccEntries_Paginated(bookingId);

              case 41:
                _context3.t4 = _context3.sent;

                if (_context3.t4) {
                  _context3.next = 44;
                  break;
                }

                _context3.t4 = [];

              case 44:
                _context3.t5 = _context3.t4;
                _context3.t6 = (0, _context3.t3)(_context3.t5);

                _context3.t1.apply.call(_context3.t1, _context3.t2, _context3.t6);

                _context3.next = 53;
                break;

              case 49:
                _context3.prev = 49;
                _context3.t7 = _context3["catch"](34);
                console.log("Error when pulling paginated TICKET type acountings");
                console.log(_context3.t7);

              case 53:
                _context3.prev = 53;
                console.log("calling getOtherTypesAccountingsByBookingId"); // lets concat the result of the below call to the bookingAccountings

                _context3.t8 = bookingAccountings.push;
                _context3.t9 = bookingAccountings;
                _context3.t10 = _toConsumableArray;
                _context3.next = 60;
                return getOtherTypesAccountingsByBookingId(bookingId);

              case 60:
                _context3.t11 = _context3.sent;

                if (_context3.t11) {
                  _context3.next = 63;
                  break;
                }

                _context3.t11 = [];

              case 63:
                _context3.t12 = _context3.t11;
                _context3.t13 = (0, _context3.t10)(_context3.t12);

                _context3.t8.apply.call(_context3.t8, _context3.t9, _context3.t13);

                _context3.next = 72;
                break;

              case 68:
                _context3.prev = 68;
                _context3.t14 = _context3["catch"](53);
                console.log("Error when pulling other type accountings");
                console.log(_context3.t14);

              case 72:
                accountingIds = bookingAccountings.map(function (acc) {
                  return acc.id;
                });
                bookingAccountingsEntries = [];
                _context3.prev = 74;
                console.log("calling getAccountingEntiesByListOfAccountingIds_Paginated"); // lets concat the result of the below call to the bookingAccountingsEntries

                _context3.t15 = bookingAccountingsEntries.push;
                _context3.t16 = bookingAccountingsEntries;
                _context3.t17 = _toConsumableArray;
                _context3.next = 81;
                return getAccountingEntiesByListOfAccountingIds_Paginated(accountingIds);

              case 81:
                _context3.t18 = _context3.sent;

                if (_context3.t18) {
                  _context3.next = 84;
                  break;
                }

                _context3.t18 = [];

              case 84:
                _context3.t19 = _context3.t18;
                _context3.t20 = (0, _context3.t17)(_context3.t19);

                _context3.t15.apply.call(_context3.t15, _context3.t16, _context3.t20);

                _context3.next = 93;
                break;

              case 89:
                _context3.prev = 89;
                _context3.t21 = _context3["catch"](74);
                console.log("Error when pulling paginated accounting entries");
                console.log(_context3.t21);

              case 93:
                // Lets now fill each accounting with its accountingEntries
                for (i = 0; i < bookingAccountings.length; i++) {
                  accounting = bookingAccountings[i];
                  accountingEntries = [];

                  for (j = 0; j < bookingAccountingsEntries.length; j++) {
                    accountingEntry = bookingAccountingsEntries[j];

                    if (accountingEntry.accountingId === accounting.id) {
                      accountingEntries.push(accountingEntry);
                    }
                  }

                  bookingAccountings[i].accountingEntriesList = accountingEntries;
                } // Lets now assing the accountings to the booking


                booking.accountings = bookingAccountings;
                console.log("------------- large booking");
                console.log(booking);
                pulledBooking = booking;
                _context3.next = 104;
                break;

              case 100:
                _context3.prev = 100;
                _context3.t22 = _context3["catch"](17);
                console.log("Error when pulling large booking");
                console.log(_context3.t22);

              case 104:
                _context3.next = 109;
                break;

              case 106:
                _context3.next = 108;
                return getFullBookingById(selectedOrderId);

              case 108:
                pulledBooking = _context3.sent;

              case 109:
                //// Pulling large bookings logic end
                LogService.info("We pulled the attached booking from backend, id: ".concat((_pulledBooking = pulledBooking) === null || _pulledBooking === void 0 ? void 0 : _pulledBooking.id), {
                  params: pulledBooking
                }); // If no pulled order then show general error to the user

                if (!pulledBooking) {
                  LogService.info("No booking with id: ".concat(selectedOrderId, " was pulled from backend"), undefined, LogLevel.Error);
                  NotificationService.showGeneralResponseError();
                } // Check if PSS is linked to PSC that is not linked to the selected Config ticketGroups


                categoryIds = _this.getPSCNotIncludedInConfig(pulledBooking);
                console.log("--------- categoryIds");
                console.log(categoryIds); // categoryIds = [43924]; //Snack 1, just to test

                if (!categoryIds.length) {
                  _context3.next = 120;
                  break;
                }

                // pull these PSC from remote and store them in indexedDB
                LogService.info("Going to pull PCs with  attached ids for Edit Order since they do not exist in current config", {
                  params: categoryIds
                });
                console.log("------------- Going to pull PCs with  attached ids for Edit Order since they do not exist in current config");
                _context3.next = 119;
                return pullAndStorePCs(categoryIds);

              case 119:
                missingPCs = _context3.sent;

              case 120:
                _context3.next = 122;
                return toLocalProductSlotBooking(pulledBooking);

              case 122:
                convertedBooking = _context3.sent;
                LogService.info("We converted pulled booking into IPSB format, result object attached", {
                  params: convertedBooking
                }); // Create an order session for the booking

                orderSession = createOrderSession({
                  bookingUuid: convertedBooking.uuid,
                  currency: convertedBooking.currency,
                  sellerId: UserModule.userId,
                  sellerCogn: AuthModule.cognitoId
                });
                orderSession.bookingId = convertedBooking.id;
                convertedBooking.orderSessions.push(orderSession); // Foreach seating PSS, if it is none-reccuring seating plan, then you need to pull its eventKey from childPSC.seatingParentResourceEventKey

                _i = 0;

              case 128:
                if (!(_i < convertedBooking.pssList.length)) {
                  _context3.next = 136;
                  break;
                }

                _context3.next = 131;
                return getProductCategoryById(convertedBooking.pssList[_i].categoryId);

              case 131:
                childPSC = _context3.sent;

                if (childPSC) {
                  // Lets check if this is a childPSC of a reccurring parent
                  if (!childPSC.isParentReccuringSeating) {
                    // so this pss is not a recurring seating plan, lets override the eventKey value of this pss
                    convertedBooking.pssList[_i].eventKey = childPSC.seatingParentResourceEventKey;
                  }
                }

              case 133:
                _i++;
                _context3.next = 128;
                break;

              case 136:
                // End of eventKey changes
                // Lets store it in bookingModule (bookings, bookingList, bookingsSteps) and consider this booking as the selected booking
                bookingUUID = convertedBooking.uuid;
                BookingModule.addBooking(convertedBooking); // If the pulled booking is of type Acompte, then we show the user the payment step (he can always go back)
                // If the pulled booking is a normal booking, then we put the user in order step

                if (openTeamsView) {
                  BookingModule.setBookingStep({
                    bookingUUID: bookingUUID,
                    step: BookingStep.Teams
                  });
                } else if (BookingModule.isAcompteBooking) {
                  BookingModule.setBookingStep({
                    bookingUUID: bookingUUID,
                    step: BookingStep.Payment
                  });
                } else {
                  BookingModule.setBookingStep({
                    bookingUUID: bookingUUID,
                    step: BookingStep.Order
                  });
                } // Now lets set the customer if we have any


                customer = (_pulledBooking2 = pulledBooking) === null || _pulledBooking2 === void 0 ? void 0 : _pulledBooking2.CustomerRead;

                if (!(convertedBooking.customerId && customer)) {
                  _context3.next = 144;
                  break;
                }

                country = customer.country, email = customer.email, phone = customer.phone, _id = customer.id, company = customer.company, address = customer.address, allergies = customer.allergies, language = customer.language, firstName = customer.firstName, lastName = customer.lastName, title = customer.title, zipCode = customer.zipCode, emailMarketingOrganiser = customer.emailMarketingOrganiser, birthDate = customer.birthDate, city = customer.city; // Lets show the customer of this booking in the UI

                _context3.next = 144;
                return CustomersModule.setSelectedCustomers([{
                  fullName: firstName + " " + lastName,
                  bookingUuid: bookingUUID,
                  checkOrder: true,
                  country: (country === null || country === void 0 ? void 0 : country.name) || "",
                  email: email,
                  phone: phone,
                  id: _id,
                  company: company,
                  address: address,
                  allergies: allergies,
                  language: language,
                  firstName: firstName,
                  lastName: lastName,
                  title: title,
                  zipCode: zipCode,
                  emailMarketingOrganiser: emailMarketingOrganiser,
                  birthDate: birthDate,
                  city: city
                }]);

              case 144:
                // For each pss lets add its extension
                pssExtensionsCopy = cloneDeep(PSSModule.pssExtensions);
                _iterator = _createForOfIteratorHelper(convertedBooking.pssList);
                _context3.prev = 146;

                _iterator.s();

              case 148:
                if ((_step = _iterator.n()).done) {
                  _context3.next = 163;
                  break;
                }

                pss = _step.value;

                if (!(pss.type !== PCTypes.Donation)) {
                  _context3.next = 160;
                  break;
                }

                _context3.next = 153;
                return getProductCategoryById(pss.categoryId);

              case 153:
                pc = _context3.sent;

                if (pc) {
                  _context3.next = 157;
                  break;
                }

                LogService.info("Error PC not found in local DB after pulling the booking, pssId: ".concat(pss.id, " from backend"), undefined, LogLevel.Error);
                return _context3.abrupt("continue", 161);

              case 157:
                pssExtensionsCopy = cloneDeep(addPSSExtensions({
                  pssExtensions: pssExtensionsCopy,
                  dt: [{
                    psc: pc,
                    pss: pss
                  }]
                }));
                _context3.next = 161;
                break;

              case 160:
                // We are in a donation pss case
                // we know we don't have its PC in localDB
                pssExtensionsCopy = cloneDeep(addPSSExtensions({
                  pssExtensions: pssExtensionsCopy,
                  dt: [{
                    psc: null,
                    pss: pss
                  }]
                }));

              case 161:
                _context3.next = 148;
                break;

              case 163:
                _context3.next = 168;
                break;

              case 165:
                _context3.prev = 165;
                _context3.t23 = _context3["catch"](146);

                _iterator.e(_context3.t23);

              case 168:
                _context3.prev = 168;

                _iterator.f();

                return _context3.finish(168);

              case 171:
                PSSModule.setPSSExtensions(pssExtensionsCopy); // save booking to indexedDB

                creationTime = dayjs().toISOString();
                untypedBooking = {
                  _id: String(convertedBooking.uuid),
                  uuid: String(convertedBooking.uuid),
                  creationDateTime: creationTime,
                  booking: convertedBooking,
                  syncStatus: SyncStatus.Synced,
                  attempts: 0
                };
                _context3.next = 176;
                return upsertUntypedBooking(untypedBooking);

              case 176:
                BookingModule.selectBooking(bookingUUID);
                _context3.next = 186;
                break;

              case 179:
                _context3.prev = 179;
                _context3.t24 = _context3["catch"](7);
                errorDetails = handleErrorAndPrepareMessage(_context3.t24);
                console.log("errorDetails");
                console.log(errorDetails);
                LogService.info("".concat(errorDetails.errorType, " Error when pulling booking with id: ").concat(selectedOrderId, " from backend"), {
                  params: {
                    err: _context3.t24,
                    errorDetails: errorDetails
                  }
                }, LogLevel.Error);
                NotificationService.showCustomMessage(errorDetails.errorMessage, "error"); // console.log(err);
                // console.log(Object.keys(err));
                // console.log(err.message);
                // console.log(err.graphQLErrors);
                // console.log(err.networkError);
                // console.log(err.extraInfo);

              case 186:
                ModalModule.setStatus(ModalStatus.Hidden);
                AppModule.updatedIsLoading(false);

              case 188:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[7, 179], [17, 100], [22, 29], [34, 49], [53, 68], [74, 89], [146, 165, 168, 171]]);
      }))();
    },
    getPSCNotIncludedInConfig: function getPSCNotIncludedInConfig(pulledBooking) {
      console.log("-------- hi from getPSCNotIncludedInConfig");
      var categoryIds = [];

      if (!POSConfigModule.getSelectedConfig) {
        console.log("----- throwing ".concat(POSConfigErrors.NoPOSConfigSelected));
        throw new Error(POSConfigErrors.NoPOSConfigSelected);
      }

      console.log("----------- no error when getting POSConfigModule.getSelectedConfig");
      var selectedConfigTicketGroups = POSConfigModule.getSelectedConfig.ticketGroups;
      console.log("----------- selectedConfigTicketGroups");
      console.log(selectedConfigTicketGroups);
      var pssList = pulledBooking.pssList;
      console.log("----------- pssList");
      console.log(pssList);

      var _loop = function _loop(i) {
        var psc = pssList[i].ProductSlotCategoryRead;
        console.log("----------- psc");
        console.log(psc);
        var pscTicketGroups = psc.TicketGroupTicketList.map(function (tg) {
          return tg.TicketGroupId;
        });
        console.log("----------- pscTicketGroups");
        console.log(pscTicketGroups);

        if (!pscTicketGroups || !pscTicketGroups.length) {
          // So this psc has no ticketGroup, it means this psc doesn't belong to any config, it means we should consider it to be pulled anyway
          console.log("----------- So this psc has no ticketGroup, it means this psc doesn't belong to any config, it means we should consider it to be pulled anyway");
          categoryIds.push(psc.Id);
        } // If at least one tgId of the PSC is not included in selectedConfigTicketGroups then we add psc.Id to categoryIds


        var _loop2 = function _loop2(j) {
          var index = selectedConfigTicketGroups.findIndex(function (it) {
            return it === pscTicketGroups[j];
          });

          if (index < 0) {
            // This psc ticketGroupId is not included in the currently selected config, lets add this categoryId to categoryIds array
            var pscId = pssList[i].ProductSlotCategoryRead.Id;
            categoryIds.push(pscId);
            return "break";
          }
        };

        for (var j = 0; j < pscTicketGroups.length; j++) {
          var _ret = _loop2(j);

          if (_ret === "break") break;
        }

        console.log("----------- done from pscTicketGroups for loop");
      };

      for (var i = 0; i < pssList.length; i++) {
        _loop(i);
      }

      console.log("----------- done from pssList for loop");
      console.log("----------- going to return categoryIds from getPSCNotIncludedInConfig");
      console.log(categoryIds);
      return categoryIds;
    }
  }
});